// ©2024 Austin App House. All rights reserved.
import React, { useState } from 'react';
import RowActions from '../../../dashboard/RowActions';
import ContractorInfoAddEdit from './ContractorInfoAddEdit';

const ContactInfoRow = ({
  contact,
  editContact,
  deleteContact,
  inputClassName,
}) => {
  const [isEdit, setIsEdit] = useState(false);

  const editContactInfo = data => {
    editContact(data);
    setIsEdit(false);
  };

  return (
    isEdit
      ? (
        <tr>
          <td colSpan={6}>
            <ContractorInfoAddEdit
              contractorToEdit={contact}
              returnContractor={editContactInfo}
              closeEdit={() => setIsEdit(false)}
              inputClassName={inputClassName}
            />
          </td>
        </tr>
      )
      : (
        <tr>
          <td>{contact?.fname || ''}</td>
          <td>{contact?.role || ''}</td>
          <td>{contact?.email || ''}</td>
          <td>{contact?.ofc_phn || ''}</td>
          <td>{contact?.mobile || ''}</td>
          <td className="actions-col">
            <RowActions
              alignEnd
              onEdit={() => setIsEdit(true)}
              onDelete={deleteContact}
            />
          </td>
        </tr>
      )
  );
};

export default ContactInfoRow;
